import React, { useState } from 'react';
import { Home, Users, Heart, Trees } from 'lucide-react';

const GalleryCategories = ({ onCategoryChange, className = "" }) => {
  const [activeCategory, setActiveCategory] = useState('all');
  
  const categories = [
    {
      id: 'all',
      label: 'All Photos',
      icon: Home,
    },
    {
      id: 'facilities',
      label: 'Facilities',
      icon: Home,
    },
    {
      id: 'community',
      label: 'Community Life',
      icon: Users,
    },
    {
      id: 'activities',
      label: 'Activities',
      icon: Heart,
    },
    {
      id: 'commonareas',
      label: 'Common Areas',
      icon: Trees,
    }
  ];

  const handleCategoryClick = (categoryId) => {
    setActiveCategory(categoryId);
    onCategoryChange(categoryId);
  };

  return (
    <div className={`py-8 sm:py-12 bg-white border-b border-gray-200 ${className}`}>
      <div className="max-w-7xl mx-auto px-1 sm:px-6 md:px-12">
        <div className="flex overflow-x-scroll gap-2 sm:gap-4">
          {categories.map((category) => {
            const IconComponent = category.icon;
            const isActive = activeCategory === category.id;
            
            return (
              <button
                key={category.id}
                onClick={() => handleCategoryClick(category.id)}
                className={`flex  flex-shrink-0 items-center gap-3 px-3 sm:px-6 py-3 sm:py-4 rounded-2xl text-sm sm:text-base font-medium transition-all duration-300 ${
                  isActive
                    ? 'bg-[var(--primarycolor)] text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                <IconComponent className="w-5 h-5" />
                <span>{category.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default GalleryCategories;